(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();

/* GW: hCaptcha notice. The floating 'Protected by hCaptcha' badge is hidden and replaced by this notice
   (hCaptcha privacy policy + terms links) under the questionnaire buttons and in the footer. */
(function () {
	var HTML = 'This site is protected by hCaptcha and its <a href="https://www.hcaptcha.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> and <a href="https://www.hcaptcha.com/terms" target="_blank" rel="noopener">Terms of Service</a> apply.';

	var addNotes = function () {
		/* footer, next to the copyright / policies */
		if (!document.querySelector('.gw-hc-footer')) {
			var host = document.querySelector('.footer__column--copyright') || document.querySelector('.footer');
			if (host) {
				var p = document.createElement('p');
				p.className = 'gw-hc gw-hc-footer';
				p.innerHTML = HTML;
				host.appendChild(p);
			}
		}
		/* questionnaire: pop-up and standalone page, under the Send buttons */
		var btns = document.querySelectorAll('.gw-cm__btns, .gw-cf__btns');
		for (var i = 0; i < btns.length; i++) {
			if (!btns[i].nextElementSibling || !btns[i].nextElementSibling.classList.contains('gw-hc')) {
				var q = document.createElement('p');
				q.className = 'gw-hc gw-hc-form';
				q.innerHTML = HTML;
				btns[i].parentNode.insertBefore(q, btns[i].nextSibling);
			}
		}
	};

	var css = document.createElement('style');
	css.textContent = '.gw-hc{font-size:11px;line-height:1.5;margin:10px 0 0;opacity:.75;text-align:center}.gw-hc a{text-decoration:underline;color:inherit}.gw-hc-footer{padding:0 16px 8px}';
	document.head.appendChild(css);

	/* hide ONLY the small floating badge (small, fixed-position box); never touches the verification challenge (large) */
	var hideNode = function (n) {
		n.style.setProperty('display', 'none', 'important');
		n.setAttribute('data-gw-hc-hidden', '1');
	};
	var isSmall = function (n) {
		var r = n.getBoundingClientRect();
		return r.width > 0 && r.width < 420 && r.height > 0 && r.height < 140;
	};
	var climbFixed = function (el) {
		var n = el;
		while (n && n !== document.body && n !== document.documentElement) {
			if (window.getComputedStyle(n).position === 'fixed') return n;
			n = n.parentNode;
		}
		return null;
	};
	var hideBadge = function () {
		/* 1) badge built from plain elements: text starts with 'Protected by hCaptcha' */
		var all = document.body ? document.body.getElementsByTagName('*') : [];
		for (var i = 0; i < all.length; i++) {
			var el = all[i];
			if (el.hasAttribute('data-gw-hc-hidden') || el.children.length > 6 || el.classList.contains('gw-hc')) continue;
			var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
			if (t.indexOf('Protected by hCaptcha') !== 0 || t.length > 70) continue;
			var f = climbFixed(el);
			if (f && isSmall(f)) hideNode(f);
			else if (isSmall(el)) hideNode(el);
		}
		/* 2) badge that is an iframe from hcaptcha: small ones only (the challenge iframe is large) */
		var ifr = document.getElementsByTagName('iframe');
		for (var j = 0; j < ifr.length; j++) {
			var fr = ifr[j];
			var src = (fr.getAttribute('src') || '') + ' ' + (fr.getAttribute('title') || '') + ' ' + (fr.id || '') + ' ' + (fr.className || '');
			if (!/hcaptcha/i.test(src) || /challenge/i.test(src)) continue;
			var fx = climbFixed(fr);
			if (fx && isSmall(fx)) hideNode(fx);
			else if (isSmall(fr) && window.getComputedStyle(fr).position === 'fixed') hideNode(fr);
		}
		/* 3) containers with hcaptcha in id/class that are fixed + small */
		var cand = document.querySelectorAll('[id*="hcaptcha" i], [class*="hcaptcha" i]');
		for (var k = 0; k < cand.length; k++) {
			var c = cand[k];
			if (c.hasAttribute('data-gw-hc-hidden') || c.tagName === 'FORM' || c.tagName === 'INPUT' || c.tagName === 'TEXTAREA') continue;
			if (window.getComputedStyle(c).position === 'fixed' && isSmall(c)) hideNode(c);
		}
	};

	var run = function () { addNotes(); hideBadge(); };
	if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
	var tries = 0;
	var iv = setInterval(function () { run(); tries++; if (tries > 30) clearInterval(iv); }, 1000);
	if (window.MutationObserver) {
		var mo = new MutationObserver(function () { hideBadge(); });
		mo.observe(document.documentElement, { childList: true, subtree: true });
	}
})();
